"use strict";

var _classCallCheck = require("/home/keoadmin/agent/_work/111/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/111/s/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Builder = /*#__PURE__*/function () {
  function Builder(task, scheduler) {
    _classCallCheck(this, Builder);
    this._meta = undefined;
    this._task = task;
    this._scheduler = scheduler;
  }
  _createClass(Builder, [{
    key: "withDescriptor",
    value: function withDescriptor(descriptor) {
      this._descriptor = descriptor;
      return this;
    }
  }, {
    key: "withMutex",
    value: function withMutex(mutex) {
      this._mutex = mutex;
      return this;
    }
  }, {
    key: "withMeta",
    value: function withMeta(meta) {
      this._meta = meta;
      return this;
    }
  }, {
    key: "runBeforeExecuting",
    value: function runBeforeExecuting(what) {
      this._onPreExecute = what;
      return this;
    }
  }, {
    key: "handleCollisions",
    value: function handleCollisions(handler) {
      this._onTaskCollision = handler;
      return this;
    }
  }, {
    key: "execute",
    value: function execute(priority) {
      return this._scheduler.enqueue({
        priority: priority,
        mutex: this._mutex,
        descriptor: this._descriptor,
        meta: this._meta,
        execute: this._task,
        onPreExecute: this._onPreExecute,
        onTaskCollision: this._onTaskCollision
      });
    }
  }]);
  return Builder;
}();
exports.default = Builder;